// extracted by mini-css-extract-plugin
export default {"issueTagBox":"styles_issueTagBox__wkfV3","title":"styles_title__wvfgM","selected":"styles_selected__2xsNi"};